import { useState } from 'react'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from 'design-system/shadcn/components/ui/hover-card'
import { CopyIcon } from 'lucide-react'

export interface IdDropDownProps {
  ids: {
    key: string
    label: string
    id: string
  }[]
  children: React.ReactNode
}

export const IdDropDown = ({
  ids,
  children,
  onCopy,
}: IdDropDownProps & { onCopy?: (id: string) => void }) => {
  const handleCopy = (id: string) => {
    navigator.clipboard.writeText(id)
    if (onCopy) {
      onCopy(id)
    }
  }

  const [isOpen, setIsOpen] = useState(false)

  return (
    <HoverCard
      openDelay={10}
      closeDelay={100}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent className="w-auto p-2">
        <div className="flex flex-col gap-2">
          <div className="text-right text-sm font-medium text-gray-600">
            Copy ID
          </div>
          <div className="h-px bg-gray-200" />
          {ids.map((item) => (
              <div
                key={item.key}
                className={`
                flex cursor-pointer items-center justify-end gap-2
                rounded p-2 text-right text-sm
                ${item.key === 'v3' ? 'text-indigo-500 hover:bg-blue-100' : 'text-indigo-500 hover:bg-blue-100'}
                transition-colors duration-150 ease-in-out
              `}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  handleCopy(item.id)
                  setIsOpen(false)
                }}
              >
                {item.label}
                <CopyIcon height={12} width={12} strokeWidth={1.4} />
                {/* {item.key !== 'v3' && <span className="text-xs text-gray-500">(click to copy)</span>} */}
              </div>
            ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}
